module.exports = __webpack_public_path__ + "img/1stgrp_bk_ts.41402c14.png";